export function formatNumber4Decimal(arr) {
  return arr.map((item) => {
    const v = item.value;

    // ⭐ null / undefined → 原樣保留
    if (v === null || v === undefined) {
      return { ...item, value: null };
    }

    // ⭐ 只處理「真的 number」
    if (typeof v !== "number" || Number.isNaN(v)) {
      return { ...item, value: null };
    }

    // ⭐ 0 不處理
    if (v === 0) {
      return { ...item, value: 0 };
    }

    // ⭐ 非 0 數字 → 取小數點後 4 位
    return {
      ...item,
      value: Number(v.toFixed(4)),
    };
  });
}
